// PDF generation utility for Personal Date Selection
import { format } from 'date-fns';

const ACTIVITY_TYPES = [
    { id: 'signing', chinese: '簽約', english: 'Signing Contracts' },
    { id: 'opening', chinese: '開業', english: 'Opening Business' },
    { id: 'starting', chinese: '動工', english: 'Starting Projects' },
    { id: 'opening_account', chinese: '開戶', english: 'Opening Account' }
];

export function openPDFWindow(exportData, targetDate, activityType) {
    const activityInfo = ACTIVITY_TYPES.find(a => a.id === activityType);
    const monthYear = format(targetDate, 'MMMM yyyy');
    const activityLabel = activityInfo ? `${activityInfo.chinese} ${activityInfo.english}` : '';
    
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    
    let html = getHTMLStart(monthYear, activityLabel);
    html += getBaZiSection(exportData);
    html += getBestDaysSection(exportData);
    
    if (exportData.days_to_avoid && exportData.days_to_avoid.length > 0) {
        html += getAvoidDaysSection(exportData);
    }
    
    html += getMonthlyOverviewSection(exportData);
    html += getHTMLEnd();
    
    printWindow.document.write(html);
    printWindow.document.close();
}

function getHTMLStart(monthYear, activityLabel) {
    return `<!DOCTYPE html><html><head><title>Personal Date Selection - ${monthYear}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:serif;padding:40px;color:#1a1a1a;line-height:1.6}
.header{text-align:center;margin-bottom:30px;padding-bottom:20px;border-bottom:2px solid #8b0000}
.header h1{font-size:28px;color:#8b0000;margin-bottom:8px}
.header .subtitle{font-size:14px;color:#666}
.section{margin-bottom:25px}
.section-title{font-size:16px;font-weight:700;color:#8b0000;margin-bottom:12px;padding-bottom:6px;border-bottom:1px solid #ddd}
.bazi-chart{display:flex;justify-content:center;gap:15px;margin:20px 0}
.pillar{text-align:center;padding:15px 20px;background:#f8f4f0;border:1px solid #d4c4b0;border-radius:8px;min-width:80px}
.pillar-label{font-size:11px;color:#666;margin-bottom:5px}
.pillar-chinese{font-size:24px;font-weight:700;color:#333}
.info-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:10px}
.info-item{display:flex;justify-content:space-between;padding:8px 12px;background:#f9f9f9;border-radius:4px}
.info-label{color:#666}
.info-value{font-weight:600}
.days-table{width:100%;border-collapse:collapse;margin-top:10px;font-size:12px}
.days-table th,.days-table td{border:1px solid #ddd;padding:8px 10px;text-align:left}
.days-table th{background:#8b0000;color:white;font-weight:600}
.days-table tr:nth-child(even){background:#f9f9f9}
.excellent{color:#047857;font-weight:600}
.good{color:#059669}
.neutral{color:#6b7280}
.poor{color:#d97706}
.avoid{color:#dc2626;font-weight:600}
.best-days{background:#f0fdf4;border:1px solid #86efac;border-radius:8px;padding:15px;margin-bottom:20px}
.avoid-days{background:#fef2f2;border:1px solid #fca5a5;border-radius:8px;padding:15px}
.footer{margin-top:30px;padding-top:15px;border-top:1px solid #ddd;font-size:11px;color:#666;text-align:center}
.no-print{text-align:center;margin-top:20px}
.no-print button{padding:10px 30px;background:#8b0000;color:white;border:none;border-radius:6px;cursor:pointer;font-size:14px}
@media print{body{padding:20px}.no-print{display:none}}
</style></head><body>
<div class="header">
<h1>個人擇日報告 Personal Date Selection Report</h1>
<div class="subtitle">${monthYear} | ${activityLabel}</div>
</div>`;
}

function getBaZiSection(data) {
    return `<div class="section">
<div class="section-title">八字命盤 Four Pillars Chart</div>
<div class="bazi-chart">
<div class="pillar"><div class="pillar-label">時柱 Hour</div><div class="pillar-chinese">${data.bazi_chart.hour_pillar}</div></div>
<div class="pillar" style="background:#fff7ed;border-color:#fb923c"><div class="pillar-label">日柱 Day</div><div class="pillar-chinese">${data.bazi_chart.day_pillar}</div></div>
<div class="pillar"><div class="pillar-label">月柱 Month</div><div class="pillar-chinese">${data.bazi_chart.month_pillar}</div></div>
<div class="pillar"><div class="pillar-label">年柱 Year</div><div class="pillar-chinese">${data.bazi_chart.year_pillar}</div></div>
</div>
<div class="info-grid">
<div class="info-item"><span class="info-label">日主 Day Master</span><span class="info-value">${data.bazi_chart.day_master}</span></div>
<div class="info-item"><span class="info-label">貴人 Nobleman</span><span class="info-value">${data.nobleman_animals.join(', ')}</span></div>
<div class="info-item"><span class="info-label">沖 Clash</span><span class="info-value" style="color:#dc2626">${data.clash_animal}</span></div>
<div class="info-item"><span class="info-label">出生日期 Birth Date</span><span class="info-value">${data.birth_info.date} ${data.birth_info.hour}</span></div>
</div>
</div>`;
}

function getBestDaysSection(data) {
    const rows = data.best_days.map(d => 
        `<tr><td>${d.date}</td><td>${d.day_pillar}</td><td>${d.day_animal}</td><td class="excellent">${d.rating}</td><td>${d.quality}</td></tr>`
    ).join('');
    
    return `<div class="section">
<div class="section-title">推薦日期 Recommended Dates (Top 5)</div>
<div class="best-days">
<table class="days-table">
<thead><tr><th>日期 Date</th><th>日柱 Day Pillar</th><th>日支 Animal</th><th>評分 Rating</th><th>等級 Quality</th></tr></thead>
<tbody>${rows}</tbody>
</table>
</div>
</div>`;
}

function getAvoidDaysSection(data) {
    const rows = data.days_to_avoid.map(d => {
        const factors = d.factors ? d.factors.join(', ') : '-';
        return `<tr><td>${d.date}</td><td>${d.day_pillar}</td><td>${d.day_animal}</td><td class="avoid">${d.rating}</td><td>${factors}</td></tr>`;
    }).join('');
    
    return `<div class="section">
<div class="section-title">避開日期 Dates to Avoid</div>
<div class="avoid-days">
<table class="days-table">
<thead><tr><th>日期 Date</th><th>日柱 Day Pillar</th><th>日支 Animal</th><th>評分 Rating</th><th>原因 Reason</th></tr></thead>
<tbody>${rows}</tbody>
</table>
</div>
</div>`;
}

function getMonthlyOverviewSection(data) {
    const rows = data.days.map(d => {
        let qualityClass = 'neutral';
        if (d.rating >= 75) qualityClass = 'excellent';
        else if (d.rating >= 55) qualityClass = 'good';
        else if (d.rating < 25) qualityClass = 'avoid';
        else if (d.rating < 40) qualityClass = 'poor';
        return `<tr><td>${d.date}</td><td>${d.day_pillar}</td><td>${d.day_officer}</td><td>${d.path}</td><td class="${qualityClass}">${d.rating}</td><td>${d.quality}</td></tr>`;
    }).join('');
    
    return `<div class="section">
<div class="section-title">月度總覽 Monthly Overview</div>
<table class="days-table">
<thead><tr><th>日期</th><th>日柱</th><th>建除</th><th>黃黑道</th><th>評分</th><th>等級</th></tr></thead>
<tbody>${rows}</tbody>
</table>
</div>`;
}

function getHTMLEnd() {
    const today = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    return `<div class="footer">
        <div>Generated on ${today}</div>
        <div style="margin-top:5px;font-weight:600;">通书 Online Tong Shu Plotter</div>
        <div style="margin-top:3px;font-size:11px;">Copyright © 2026 Steven Yong - Digital Dive Coaching Sdn. Bhd. All rights reserved worldwide.</div>
    </div>
<div class="no-print"><button onclick="window.print()">Print / Save as PDF</button></div>
</body></html>`;
}

// PDF export for Monthly Hexagram Readings
export function openHexagramPDFWindow(monthData, dayMaster, year) {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    
    let html = getHexagramHTMLStart(monthData, dayMaster, year);
    html += getTenGodSection(monthData);
    html += getHexagramSection(monthData);
    html += getStrategicSection(monthData);
    html += getHexagramHTMLEnd();
    
    printWindow.document.write(html);
    printWindow.document.close();
}

function getHexagramHTMLStart(monthData, dayMaster, year) {
    const monthName = monthData.month_name || '';
    const tenGod = monthData.ten_god || {};
    const hexagram = monthData.hexagram || {};
    
    return `<!DOCTYPE html><html><head><title>Monthly Hexagram Reading - ${monthName} ${year}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:serif;padding:40px;color:#1a1a1a;line-height:1.8;max-width:800px;margin:0 auto}
.header{text-align:center;margin-bottom:30px;padding-bottom:20px;border-bottom:2px solid #8b0000}
.header h1{font-size:26px;color:#8b0000;margin-bottom:8px}
.header .subtitle{font-size:14px;color:#666}
.header .month-badge{display:inline-block;background:#8b0000;color:white;padding:5px 15px;border-radius:20px;font-size:14px;margin-top:10px}
.section{margin-bottom:30px;page-break-inside:avoid}
.section-title{font-size:18px;font-weight:700;color:#8b0000;margin-bottom:15px;padding-bottom:8px;border-bottom:1px solid #ddd;display:flex;align-items:center;gap:10px}
.section-icon{font-size:20px}
.pillar-display{display:flex;justify-content:center;gap:20px;margin:20px 0;flex-wrap:wrap}
.pillar-box{text-align:center;padding:15px 25px;background:#f8f4f0;border:1px solid #d4c4b0;border-radius:10px}
.pillar-label{font-size:11px;color:#666;margin-bottom:5px;text-transform:uppercase}
.pillar-chinese{font-size:32px;font-weight:700;color:#333}
.pillar-english{font-size:12px;color:#666;margin-top:5px}
.hexagram-display{text-align:center;margin:25px 0}
.hexagram-lines{display:flex;flex-direction:column;gap:6px;align-items:center;margin-bottom:15px}
.hex-line{height:8px;border-radius:4px;background:#1a1a1a}
.hex-line.yang{width:80px}
.hex-line.yin{width:35px}
.hex-line-row{display:flex;gap:10px}
.hexagram-name{font-size:28px;font-weight:700;color:#333}
.hexagram-english{font-size:16px;color:#666;margin-top:5px}
.forecast-text{background:#fafafa;border:1px solid #e5e5e5;border-radius:10px;padding:25px;margin-top:15px}
.forecast-text p{margin-bottom:15px;text-align:justify}
.forecast-text p:last-child{margin-bottom:0}
.info-row{display:flex;justify-content:center;gap:15px;margin:15px 0;flex-wrap:wrap}
.info-badge{background:#f3f4f6;padding:8px 15px;border-radius:20px;font-size:13px}
.info-badge.keyword{background:#7c3aed;color:white}
.info-badge.tengod{background:#f59e0b;color:white}
.summary-box{background:#fffbeb;border:1px solid #fcd34d;border-radius:10px;padding:15px;margin-bottom:15px;font-style:italic}
.footer{margin-top:40px;padding-top:15px;border-top:1px solid #ddd;font-size:11px;color:#666;text-align:center}
.no-print{text-align:center;margin-top:25px}
.no-print button{padding:12px 35px;background:#8b0000;color:white;border:none;border-radius:6px;cursor:pointer;font-size:14px;font-weight:600}
.no-print button:hover{background:#6b0000}
@media print{body{padding:20px}.no-print{display:none}.section{page-break-inside:avoid}}
</style></head><body>
<div class="header">
<h1>月度卦象解讀 Monthly Hexagram Reading</h1>
<div class="subtitle">${year}年 ${monthData.gregorian_year || year}</div>
<div class="month-badge">${monthName.toUpperCase()} ${monthData.gregorian_year || year}</div>
</div>

<div class="pillar-display">
<div class="pillar-box">
<div class="pillar-label">Day Master 日主</div>
<div class="pillar-chinese">${dayMaster?.stem?.chinese || ''}</div>
<div class="pillar-english">${dayMaster?.stem?.english || ''} ${dayMaster?.element || ''}</div>
</div>
<div class="pillar-box">
<div class="pillar-label">Month Pillar 月柱</div>
<div class="pillar-chinese">${monthData.pillar_chinese || ''}</div>
<div class="pillar-english">${monthData.stem?.english || ''} ${monthData.branch?.english || ''}</div>
</div>
</div>`;
}

function getTenGodSection(monthData) {
    const tenGod = monthData.ten_god || {};
    const TEN_GOD_FORECASTS = {
        'Direct Companion': { keyword: 'Collaboration', summary: 'A month of peer connections and mutual support' },
        'Rob Wealth': { keyword: 'Competition', summary: 'A month of challenges and assertive energy' },
        'Eating God': { keyword: 'Creativity', summary: 'A month of creative expression and enjoyment' },
        'Hurting Officer': { keyword: 'Innovation', summary: 'A month of bold ideas and challenging conventions' },
        'Direct Wealth': { keyword: 'Stability', summary: 'A month of steady gains and financial focus' },
        'Indirect Wealth': { keyword: 'Opportunity', summary: 'A month of unexpected gains and diverse income' },
        'Direct Officer': { keyword: 'Recognition', summary: 'A month of career advancement and authority' },
        'Seven Killings': { keyword: 'Power', summary: 'A month of intensity and transformative challenges' },
        'Direct Resource': { keyword: 'Wisdom', summary: 'A month of learning and supportive guidance' },
        'Indirect Resource': { keyword: 'Intuition', summary: 'A month of spiritual insight and unconventional wisdom' }
    };
    
    const forecast = TEN_GOD_FORECASTS[tenGod.english] || {};
    
    if (!tenGod.chinese) return '';
    
    return `<div class="section">
<div class="section-title"><span class="section-icon">🔮</span> Ten God Reading 十神解讀: ${tenGod.chinese} ${tenGod.english}</div>
<div class="info-row">
<div class="info-badge keyword">${forecast.keyword || ''}</div>
<div class="info-badge tengod">${tenGod.chinese} ${tenGod.english}</div>
</div>
<div class="summary-box">${forecast.summary || ''}</div>
</div>`;
}

function getHexagramSection(monthData) {
    const hexagram = monthData.hexagram || {};
    if (!hexagram.chinese) return '';
    
    // Generate hexagram lines HTML
    const lines = hexagram.lines || '';
    let linesHTML = '';
    if (lines) {
        // Reverse for display (line 6 at top)
        const linesArray = lines.split('').reverse();
        linesHTML = linesArray.map(line => {
            if (line === '1') {
                return '<div class="hex-line yang"></div>';
            } else {
                return '<div class="hex-line-row"><div class="hex-line yin"></div><div class="hex-line yin"></div></div>';
            }
        }).join('');
    }
    
    // Format forecast paragraphs
    const forecastHTML = hexagram.forecast ? 
        hexagram.forecast.split('\n\n').map(p => `<p>${p}</p>`).join('') : '';
    
    return `<div class="section">
<div class="section-title"><span class="section-icon">☯</span> Hexagram Reading 卦象解讀: ${hexagram.chinese} ${hexagram.english}</div>
<div class="hexagram-display">
<div class="hexagram-lines">${linesHTML}</div>
<div class="hexagram-name">${hexagram.chinese}</div>
<div class="hexagram-english">${hexagram.english} (${hexagram.pinyin || ''})</div>
</div>
${forecastHTML ? `<div class="forecast-text">${forecastHTML}</div>` : ''}
</div>`;
}

function getStrategicSection(monthData) {
    const tenGod = monthData.ten_god || {};
    const pillarName = `${monthData.pillar_chinese || ''} ${monthData.stem?.pinyin || ''} ${monthData.branch?.english || ''}`;
    
    // Strategic recommendations based on Ten God
    const STRATEGIC_RECS = {
        'Direct Companion': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents a unique blend of collaborative opportunities. The energy influencing your path is characterized by partnership and equality, which can be both empowering and challenging in competitive environments.

Your natural ability to work alongside others is your greatest asset this month. However, the challenge lies in maintaining your individual voice while being part of a collective. There's a risk of blending in too much or deferring important decisions to others when you should be taking the lead.

To navigate this period, focus on leveraging your network while maintaining clear boundaries. Active collaboration will be crucial, but ensure you're not sacrificing your own goals for the sake of harmony. This approach not only strengthens team dynamics but also establishes your unique value within any partnership.

Your diplomatic skills can be a powerful tool in building strategic alliances. Ensure that your contributions are recognized and that shared projects have clear accountability structures. Don't let the spirit of cooperation mask underlying competition for resources or recognition.

This month calls for a reflection on how to balance teamwork with personal ambition. With strategic networking and mindful collaboration, you can transform peer relationships into opportunities for mutual growth and success.`,
        'Rob Wealth': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents a challenging landscape of competition and assertion. The energy influencing your path is characterized by intensity and rivalry, which demands vigilance and strategic thinking.

Your competitive drive is heightened this month, which can propel you forward but also create unnecessary conflicts. The challenge lies in channeling this aggressive energy constructively - knowing when to push forward and when to hold back.

To navigate this period, focus on strategic positioning rather than direct confrontation. Active awareness of competitive dynamics will be crucial in avoiding pitfalls. Protect your interests without burning bridges that may be valuable later.

This month calls for a reflection on sustainable success versus short-term wins. With strategic restraint and calculated moves, you can outmaneuver competition while building a reputation for both strength and integrity.`,
        'Eating God': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents a creative and expressive landscape. The energy influencing your path is characterized by inspiration and eloquence, which can be both captivating and potentially unfocused.

Your natural charm and creative abilities are your greatest strengths this month. Your persuasive communication style can win hearts and minds. However, the challenge lies in balancing creative expression with practical execution.

To navigate this period, focus on harnessing your creative energy while maintaining disciplined follow-through. Use your expressive abilities to articulate clear strategies, not just inspire general enthusiasm.

This month calls for a reflection on turning creative potential into tangible outcomes. With strategic focus and mindful communication, you can transform your innovative ideas into recognized achievements and career advancement.`,
        'Hurting Officer': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents a unique blend of challenges and opportunities. The energy influencing your path is characterized by a rebellious and unconventional spirit, which can be both an asset and a liability.

Your persuasive charm and diplomatic skills are your greatest strengths, yet they may also lead to self-induced conflicts. Your tendency to embrace innovation and creative approaches sets you apart. However, the challenge lies in balancing your persuasive leadership with effective communication strategies.

While you have the ability to charm and influence, there's a risk of miscommunication or misunderstandings. To navigate this period, focus on harnessing your charisma while being mindful of your interactions. Active listening and empathy will be crucial.

This month calls for a reflection on how to use your unique qualities to inspire and lead, while being cautious about communication pitfalls. With a strategic approach and mindful leadership, you can transform challenges into opportunities.`,
        'Direct Wealth': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents a stable, methodical landscape. The energy influencing your path is characterized by practicality and accumulation, which favors measured decisions over risky ventures.

Your ability to manage resources and build sustainable foundations is your greatest strength this month. Your methodical approach inspires confidence in stakeholders and team members.

To navigate this period, focus on balancing prudent planning with timely action. Use your practical skills to evaluate opportunities quickly and commit to well-researched decisions with confidence.

This month calls for a reflection on building lasting value versus chasing quick gains. With strategic patience and grounded decision-making, you can establish foundations that support sustained growth.`,
        'Indirect Wealth': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents an opportunistic landscape full of unexpected possibilities. The energy influencing your path is characterized by flexibility and fortune, which favors bold moves and calculated risks.

Your ability to spot opportunities others miss is your greatest strength this month. Your adaptable nature allows quick pivots when circumstances change.

To navigate this period, focus on evaluating opportunities against your core objectives. Your intuition for profitable ventures will be heightened, but ensure due diligence accompanies enthusiasm.

This month calls for a reflection on strategic opportunity selection versus scattered pursuits. With focused opportunism and disciplined evaluation, you can capitalize on unexpected windfalls.`,
        'Direct Officer': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents an authoritative landscape favoring structure and recognition. The energy influencing your path is characterized by legitimacy and advancement.

Your ability to work within established systems and earn official recognition is your greatest strength. Your respect for proper procedures builds credibility with superiors.

To navigate this period, focus on leveraging institutional support while maintaining flexibility. Your professional reputation will be enhanced through demonstrated competence and reliability.

This month calls for a reflection on earning advancement through merit and proper channels. With strategic professionalism and demonstrated leadership, you can secure recognition and opportunities.`,
        'Seven Killings': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents an intense, transformative landscape. The energy influencing your path is characterized by pressure and power.

Your ability to thrive under pressure and confront obstacles directly is your greatest strength. Your fearless approach commands respect and can break through stagnant situations.

To navigate this period, focus on channeling aggressive energy toward worthy goals. Use your strength strategically - knowing when to push hard and when to consolidate gains.

This month calls for a reflection on sustainable power versus destructive force. With strategic intensity and controlled aggression, you can overcome major obstacles and emerge stronger.`,
        'Direct Resource': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents a supportive, nurturing landscape. The energy influencing your path is characterized by wisdom and guidance.

Your ability to absorb knowledge and receive support from others is your greatest strength. Your receptive nature allows you to benefit from experienced advisors.

To navigate this period, focus on gathering insights while building confidence in your own judgment. Use your learning to inform bold decisions, demonstrating that education translates to effective action.

This month calls for a reflection on transforming knowledge into leadership. With strategic learning and growing confidence, you can establish yourself as both wise counsel and decisive leader.`,
        'Indirect Resource': `In the realm of decision-making and leadership this month, ${pillarName} engages with your Career & Work Palace and presents an intuitive, unconventional landscape. The energy influencing your path is characterized by insight and alternative thinking.

Your ability to perceive patterns and solutions others miss is your greatest strength. Your unconventional thinking can unlock breakthrough strategies.

To navigate this period, focus on grounding your intuitions in practical frameworks. Use your insight to anticipate challenges and opportunities before they become obvious to others.

This month calls for a reflection on balancing intuition with communication. With strategic articulation of your insights, you can establish yourself as a visionary leader.`
    };
    
    if (!tenGod.english || !STRATEGIC_RECS[tenGod.english]) return '';
    
    const strategicHTML = STRATEGIC_RECS[tenGod.english].split('\n\n').map(p => `<p>${p}</p>`).join('');
    
    return `<div class="section">
<div class="section-title" style="color:#047857;border-color:#a7f3d0;"><span class="section-icon">📊</span> Strategic and Decision-Making Recommendations</div>
<div class="forecast-text" style="border-color:#a7f3d0;background:#ecfdf5;">${strategicHTML}</div>
</div>`;
}

function getHexagramHTMLEnd() {
    const today = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    return `<div class="footer">
        <div>Generated on ${today}</div>
        <div style="margin-top:5px;font-weight:600;">通书 Online Tong Shu Plotter</div>
        <div style="margin-top:3px;font-size:11px;">Copyright © 2026 Steven Yong - Digital Dive Coaching Sdn. Bhd. All rights reserved worldwide.</div>
    </div>
<div class="no-print"><button onclick="window.print()">Print / Save as PDF</button></div>
</body></html>`;
}
